export default {
      id: "ic_live_icon-usage",
      viewBox: "0 0 60 40",
      url: "/" + "images/icons.3.109.2.svg#ic_live_icon-usage",
      toString: function () {
        return this.url;
      }
    }